const attention = {
  open: '알림 열기',
  close: '알림 닫기',
  title: '알림',
  intro: '확인이 필요한 새 리드, 사람 상담 요청, 응답 기한을 한곳에 모읍니다.',
  unreadCount: '읽지 않음 {count}개',
  markAll: '모두 읽음',
  filter: { all: '전체', unread: '읽지 않음', lead: '새 리드', human: '사람 상담' },
  kind: {
    lead_created: '새 유효 리드 도착',
    human_handoff_requested: '구매자가 사람의 도움을 요청함',
    sla_warning: '첫 응답 마감 임박',
    sla_overdue: '응답 기한이 지났습니다',
  },
  body: {
    lead_created: '구매자가 연락을 허용했습니다. 해당 리드에서 처리를 계속하세요.',
    human_handoff_requested: '원래 Airlock 대화 또는 이미 생성된 관련 리드를 여세요.',
    sla_warning: '이 리드에는 현재 단계에 필요한 담당자 조치가 아직 없습니다.',
    sla_overdue: '고정된 응답 기한이 지났지만 필요한 조치가 완료되지 않았습니다.',
  },
  target: { lead: '리드 상세', conversation: '접수 원본 대화' },
  openTarget: '처리하기',
  markRead: '읽음 표시',
  read: '읽음',
  unread: '읽지 않음',
  urgent: '우선',
  emptyTitle: '확인이 필요한 항목이 없습니다',
  emptyBody: '새 업무 이벤트는 여기에 표시되지만 리드 처리 상태를 바꾸지 않습니다.',
  loading: '새 알림 확인 중…',
  failed: '알림을 불러오지 못했습니다.',
  retry: '다시 시도',
  newToast: '새 알림 {count}개가 도착했습니다',
  boundary: '읽음 상태는 이 알림함에만 적용됩니다. 배정, 후속 조치, 결과는 리드 흐름에서 완료합니다.',
  emailBoundary: '이메일은 기업 설정을 따릅니다. 이메일 실패로 앱 내 알림이 사라지지 않습니다.',
  justNow: '방금',
  minutesAgo: '{count}분 전',
  hoursAgo: '{count}시간 전',
  daysAgo: '{count}일 전',
} as const

export default attention
